<template>
    <div class="flex w-full">
        <div class="w-1/6 mr-4">
            <div>
                <label class="text-sm text-grey-darkest">Filter by Fixed Date</label>
                <multiselect :options="dateRanges"
                            v-model="selectedFixedDateRangeIdentifier"
                            :show-labels="false"
                            @input="setFixedDateRange(selectedFixedDateRangeIdentifier)"
                            @remove="clearDates"
                            track-by="id" label="name" class="mb-2 cursor-pointer">
                </multiselect>
            </div>
        </div>
        <div class="w-1/5 mr-4">
            <div class="flex">
                <v-date-picker v-model="selectedDateRange" is-range :masks="rangeMask" @input="setFixedDateRange({id:0})" :popover="{ visibility: 'click' }">
                    <template v-slot="{ inputValue, inputEvents }">
                        <div class="flex w-full">
                            <div class="flex-column mr-2">
                                <label class="text-sm text-grey-darkest">Start Date</label>
                                <input
                                    :value="inputValue.start"
                                    v-on="inputEvents.start"
                                    class=" mr-1 cursor-pointer date-picker-input border-1 border-grey focus:outline-none px-2 rounded-l rounded-r text-grey-darkest text-sm w-full"
                                />
                            </div>
                            <div class="flex-column">
                                <label class="text-sm text-grey-darkest">End Date</label>
                                <input
                                    :value="inputValue.end"
                                    v-on="inputEvents.end"
                                    class="cursor-pointer date-picker-input border-1 border-grey focus:outline-none px-2 rounded-l text-grey-darkest text-sm w-full"
                                />
                            </div>
                        </div>
                    </template>
                </v-date-picker>
                <div class="flex-column">
                    <label class="text-sm text-grey-darkest"></label>
                    <div
                        class="-ml-0 border-b-1 border-grey border-r-1 border-t-1 cursor-pointer flex hover:bg-grey hover:text-white text-grey-darkest items-center px-2 rounded-r cross-btn"
                        @click.stop="clearDates">
                        <i class="material-icons text-sm">clear</i>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-1/6 mr-4">
            <label class="text-sm text-grey-darkest">Filter by User</label>
            <multiselect class="cursor-pointer" :options="users" v-model="selectedUser" :show-labels="false"
                        track-by="id" label="name"></multiselect>
        </div>
        <div class="w-1/6 mr-4">
            <div>
                <label class="text-sm text-grey-darkest">Filter by {{ getFieldLabel(fieldLabels , 'office') }}</label>
                <multiselect :options="offices"
                            v-model="selectedOffice"
                            :show-labels="false"
                            @remove="selectedOffice = null"
                            track-by="id" label="code" class="mb-2 cursor-pointer">
                </multiselect>
            </div>
        </div>
        <div class="w-1/6 mr-4">
            <div>
                <label class="text-sm text-grey-darkest">Filter by {{ getFieldLabel(fieldLabels , 'contract-type') }}</label>
                <multiselect :options="contractTypes"
                            v-model="selectedContractType"
                            :show-labels="false"
                            track-by="id" label="code" class="mb-2 cursor-pointer">
                </multiselect>
            </div>
        </div>
        <div class="mt-8">
            <button
                class="py-2 focus:outline-none border-1 border-followup-nav hover:bg-followup-nav hover:text-white px-3 rounded-full text-followup-nav"
                @click="applyFilter" type="button">
                Apply
            </button>
        </div>
    </div>
</template>

<script>

    import Datepicker from 'vuejs-datepicker';
    import Multiselect from 'vue-multiselect';
    import moment from 'moment';
    // import 'v-calendar/lib/v-calendar.min.css';

    export default {
        name: 'report-card-filter',

        components: {Datepicker, Multiselect},
        props: ['date-range', 'project_management','fixed-date-range-identifier', 'user', 'office', 'contract-type', 'masks','fieldLabels'],

        created() {
            this.fetchData();
            this.getContractTypes();
            this.getOffices();
        },

        data() {
            return {
                rangeMask: {
                    input: this.masks.moment_mask,
                },
                dateRanges: [],
                users: [],
                project_management:false,
                selectedUser: this.user ? this.user : null,
                selectedDateRange: this.dateRange ? {
                    start: moment(this.dateRange.start).format('MM/DD/YYYY'),
                    end: moment(this.dateRange.end).format('MM/DD/YYYY')
                } : null,
                selectedFixedDateRangeIdentifier: this.fixedDateRangeIdentifier !== null ? this.fixedDateRangeIdentifier : null,
                offices: [],
                selectedOffice: null,
                contractTypes: [],
                selectedContractType: null,
            }
        },

        methods: {
            fetchData() {
                let self = this;
                axios.get(route('date-ranges')).then((data) => {
                    self.users = data.data.users;
                    self.dateRanges = data.data.dateRanges;
                });
            },

            setFixedDateRange(dateRange) {
                if (!dateRange) return;
                this.selectedFixedDateRangeIdentifier = this.dateRanges[dateRange.id];
                if(dateRange.id > 0)
                    this.selectedDateRange = {
                        start: moment(this.dateRanges[dateRange.id].startDate).format('MM/DD/YYYY'),
                        end: moment(this.dateRanges[dateRange.id].endDate).format('MM/DD/YYYY')
                    };
            },

            clearDates() {
                this.selectedDateRange = null;
                this.selectedFixedDateRangeIdentifier = null;
            },

            getOffices() {
                let self = this;
                axios.get(route('report-card.offices')).then((response) => {
                    self.offices = response.data;
                    self.offices.unshift({id: 0, code: 'All'});
                    let office = this.office;
                    if(office) {
                        self.selectedOffice = _.find(self.offices, function(o) { return o.id === Number(office); })
                    }
                });
            },

            getContractTypes() {
                let self = this;
                axios.get(route('report-card.contract-types')).then((response) => {
                    self.contractTypes = response.data;
                    self.contractTypes.unshift({id: 0, code: 'All'});
                    let contract = this.contractType;
                    if(contract != undefined) {
                        self.selectedContractType = _.find(self.contractTypes, function(o) { return o.id === Number(contract); })
                    }
                });
            },


            applyFilter() {
                let uri = "";

                if (this.selectedDateRange) {
                    uri += "?start-date=" + moment(this.selectedDateRange.start).format('l') + "&end-date=" + moment(this.selectedDateRange.end).format('l');
                } else {
                    uri += "?start-date=&end-date=";
                }

                if (this.selectedFixedDateRangeIdentifier) {
                    uri += "&fixed-date-range-identifier=" + this.selectedFixedDateRangeIdentifier.id;
                }

                if (this.selectedUser) {
                    uri += "&user=" + this.selectedUser.id;
                }

                if (this.selectedContractType) {
                    uri += "&contract-type=" + this.selectedContractType.id;
                }

                if (this.selectedOffice) {
                    uri += "&office=" + this.selectedOffice.id;
                }

                if(this.project_management){

                    window.location = "/project-management/report-card" + uri;
                }else {
                    window.location = "/report-card" + uri;
                }
            },
            maxDate(){
                return moment().add(1, 'y').toDate();
            },
            formatDateRange(){
                if(!this.selectedDateRange)
                    return '';

                let dates = this.selectedDateRange;
                return `${moment(dates.start).format(this.masks.moment_mask)} - ${moment(dates.end).format(this.masks.moment_mask)}`;
            },
        },

    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
    .date-picker-input {
        padding: .61rem .5rem !important;
    }
    .cross-btn {
        height: 38px;
        margin-top: 7px;
    }
</style>
